//
import Service from '@/services/API/Service'
import SlSaleCreditNoteModel from '@/models/Sale/SlSaleCreditNote'
import PrinterService from '@/services/printerApi'
import { dateToYYYYMMDDHHmmSS } from '@/services/JSUtils'

/**
 * 
 */
export default class SlSaleCreditNote extends Service {

  /**
   * 
   */
  static getFirstByNumber(number) {
    return this
      .model()
      .include('sl_detail_sale_credit_notes.wh_product,sl_service_order.sl_sale_ticket_affected')
      .where('number', number)
      .first()
  }

  /**
   * 
   */
  static getPrinterServiceTimeout() {
    return parseInt(process.env.VUE_APP_PRINTER_SERVICE_TIMEOUT || '0')
  }

  /**
   * 
   */
  static model() {
    return SlSaleCreditNoteModel
  }

  /**
   * 
   */
  static async printByNumber(payload) {

    //
    const PRINTER_SERVICE_TIMEOUT = this.getPrinterServiceTimeout()

    // Will resolve after 0ms
    let printPromise = new Promise((resolve, reject) => {
      let wait = setTimeout(() => {
        clearTimeout(wait);
        resolve(this.printWithServiceByNumber(payload));
      }, 0)
    })
    
    // Will resolve after 6000ms
    let timePromise = new Promise((resolve, reject) => {
      let wait = setTimeout(() => {
        clearTimeout(wait);
        reject('Tiempo de espera agotado.');
      }, PRINTER_SERVICE_TIMEOUT)
    })

    // promises
    let promises = [
      printPromise,
      timePromise,
    ]

    // print with timeout
    return Promise.race(promises).catch(() => {
      this.printHtmlByNumber(payload)
    })
  }

  /**
   * 
   */
  static async printHtmlByNumber(payload) {
    return this.getFirstByNumber(payload.number).then(slSaleCreditNote => {
      return slSaleCreditNote.printHtml(payload.company, payload.office)
    })
  }

  /**
   * 
   */
  static async printWithServiceByNumber(payload) {

    //
    const slSaleCreditNote = await this.getFirstByNumber(payload.number);

    // flags
    const isIntegration = payload.provider === 'integration'

    // getters
    const companyRes          = this.getter('SessionModule/companyRes')
    const roundingLaw         = this.getter('CashDeskModule/roundingLaw')
    const salePaid            = this.getter('CashDeskModule/salePaid')
    const totalAmountDiscount = this.getter('CashDeskModule/amountDiscount')
    const totalSale           = this.getter('CashDeskModule/saleTotal')
    const totalDiscountCharge = this.getter('CashDeskModule/currentDiscountOrChargePercentage')

    // integration options
    const headerPrefix    = isIntegration ? 'TICKET DE VENTA N°' : 'Nro'
    const headerSubtitle  = isIntegration ? 'DOCUMENTO NO VÁLIDO CÓMO BOLETA' : 'NOTA DE CRÉDITO ELECTRÓNICA'
    const signatureURL    = isIntegration ? '' : payload.signature
    const signatureTitle  = isIntegration ? '' : 'TIMBRE ELECTRÓNICO SII'
    const signatureRes    = isIntegration ? '' : companyRes

    // payload options
    const totalCashChange   = payload.options ? payload.options.change || 0 : 0
    const totalRoundingLaw  = payload.options ? payload.options.roundingLaw : roundingLaw

    // others
    const totalToPay    = parseInt(totalSale) + parseInt(totalRoundingLaw)
    const totalDiscount = totalAmountDiscount && !totalDiscountCharge ? -1 * parseInt(totalAmountDiscount) : 0

    //
    return PrinterService.printRaw({

      // company
      company_name                : this.getter('SessionModule/companyName'),

      // header
      header_footer               : `${ headerPrefix }: ${ payload.number }`,
      header_rut                  : this.getter('SessionModule/companyRut'),
      header_subtitle             : `${ headerSubtitle }`,

      // business
      business_address            : this.getter('SessionModule/companyAddress'),
      business_branch_office      : this.getter('AuthModule/branchOfficeName'),
      business_cash_desk          : this.getter('AuthModule/cashDeskID'),
      business_cashier            : this.getter('AuthModule/userName'),
      business_commercial_business: this.getter('SessionModule/companyCommercialBusiness'),
      business_employee           : '', 
      business_phone              : '',
      business_seller             : '',
      business_title              : '',

      // total
      total                       : parseInt(totalSale),
      total_cash_change           : parseInt(totalCashChange),
      total_discount              : parseInt(totalDiscount),
      total_discount_percentage   : parseInt(totalDiscountCharge),
      total_paid                  : parseInt(salePaid),
      total_rounding_law          : parseInt(totalRoundingLaw),
      total_subtotal              : this.getter('CashDeskModule/subTotal'),
      total_to_pay                : parseInt(totalToPay),

      // sale
      sale_date_time              : dateToYYYYMMDDHHmmSS(new Date()),
      sale_payment_message        : 'Referencia',
      sale_payments               : slSaleCreditNote.slSalePaymentsDetail,

      // signature
      signature_url               : signatureURL,
      signature_title             : signatureTitle,
      signature_res               : signatureRes,
      
      // others
      detail_product_message      : 'DETALLE DE VENTA',
      discount_text               : '',
      footer_text                 : '',
      sale_products               : slSaleCreditNote.slSaleProductsDetail,
    })
  }
}